import { render, staticRenderFns } from "./k-form-fullscreen.vue?vue&type=template&id=25a04166&scoped=true&"
import script from "./k-form-fullscreen.vue?vue&type=script&lang=ts&"
export * from "./k-form-fullscreen.vue?vue&type=script&lang=ts&"
import style0 from "./k-form-fullscreen.vue?vue&type=style&index=0&id=25a04166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a04166",
  null
  
)

export default component.exports